import { AxiosError, AxiosResponse } from 'axios';
import { action, actionBound, observable } from 'mobx';
import { AuthService, BankFormResponse } from '../CommonInterfaces';
import config from '../Config';
import { BANK } from '../Routes';
import { API, resolveSsoOrigin } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import { paramsWithAdditionalParams } from '../util/ForwardParamsUtil';
import GaDataStore from './GaDataStore';
import { mapAuthServiceToGaAuthType } from './LoginReturnStore';
import RootStore from './RootStore';
import RouteStore from './RouteStore';
import RememberMeStore from './RememberMeStore';

export default class BanksLoginStore {
  @observable accessor error: boolean = false;
  @observable accessor errorCode: string = '';
  @observable accessor mountBankForm: boolean = false;
  @observable accessor bankFormInitialized: boolean = false;
  @observable accessor formPostUrl: string | undefined;
  @observable accessor redirectData: Map<string, string> = new Map();

  public bankLoginInitialPath: string = '';

  private routeStore: RouteStore;
  private rememberMeStore: RememberMeStore;

  constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.rememberMeStore = rootStore.rememberMeStore;
  }

  @actionBound
  public async handleBankClick(service: AuthService) {
    const { params, pathname } = this.routeStore;
    this.bankLoginInitialPath = pathname + params;
    const redirectUrl =
      BANK.replace(':authService', service) +
      paramsWithAdditionalParams(this.routeStore.formForwardParamsForStartExternalAuth, { originalReferrer: resolveSsoOrigin() });
    if (window.top === window && !config.isModule) {
      this.routeStore.route(redirectUrl);
    } else if (config.isModule) {
      window.top!.location.href = `${config.frontendUrl}${redirectUrl}`;
    } else {
      window.top!.location.href = redirectUrl;
    }
  }

  public initializeBankFormData(authService: string) {
    const formForwardParams = paramsWithAdditionalParams(this.routeStore.formForwardParams, {
      originalReferrer: (this.routeStore.getParameter('originalReferrer') as string) || resolveSsoOrigin(),
    });
    const url = `/bank/auth/${authService}${formForwardParams ? formForwardParams : ''}`;
    return API.get(url)
      .then((response) => this.handleSuccess(response, authService))
      .catch((e: Error | string | any) => this.handleError(e, authService));
  }

  private handleError = (e: AxiosError, authService: string) => {
    ErrorUtil.pushErrorToTeliaRumAndLog(e);
    this.routeStore.route(this.bankLoginInitialPath);
    GaDataStore.loginStatus(false, mapAuthServiceToGaAuthType[authService], this.rememberMeStore.rememberMe);
  };

  @actionBound
  private handleSuccess(response: AxiosResponse, authService: string) {
    const loginResponse: BankFormResponse = response.data;
    this.formPostUrl = loginResponse.params.formPostUrl;
    this.redirectData = new Map(Object.entries(loginResponse.params.redirectData || {}));
    this.bankFormInitialized = true;
    GaDataStore.loginStatus(true, mapAuthServiceToGaAuthType[authService], this.rememberMeStore.rememberMe);
  }
}
